import { Link } from '@servicetitan/anvil2';
import { Spinner } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import { CallerIdDisplay } from './CallerIdDisplay';
import styles from './DisplayAgentCallerId.module.css';
import { inboxLocators } from '@locators/inbox';

interface DisplayAgentCallerIdProps {
  callerName?: string;
  callerId?: string;
  className?: string;
  loading: boolean;
  showChangeButton: boolean;
  onEditClick: () => void;
}

export const DisplayAgentCallerId: FC<DisplayAgentCallerIdProps> = ({
  className,
  callerId,
  callerName,
  loading,
  showChangeButton,
  onEditClick,
}) => {
  return (
    <div className={classNames(styles.agentCallerIdContainer, className)}>
      {loading ? (
        <Spinner
          size='tiny'
          className='align-self-center'
          data-testid={inboxLocators.callBar.agentCallerIdLoader}
        />
      ) : (
        <CallerIdDisplay callerId={callerId} callerName={callerName} />
      )}
      {showChangeButton && (
        <Link
          quiet
          onClick={onEditClick}
          className={styles.changeButton}
          data-testid={inboxLocators.callBar.agentCallerIdChangeButton}
        >
          Change
        </Link>
      )}
    </div>
  );
};
